import { Box } from '@iheartjane/reefer';
import { useMemo } from 'react';
import type { ReactNode } from 'react';

import { PromptContent } from './promptContent';
import { PromptContext } from './promptContext';

import styles from './prompt.module.css';

/**
 * The prompt component displays a popover below the passed target (desktop only).
 * If passed the dismissible prop, the prompt will persist until the x button is clicked.
 * The prompt visibility is controlled by the parent via showPrompt/dismissPrompt props.
 */

export interface PromptProps {
  children: ReactNode;
  dismissible?: boolean;
  dismissPrompt: () => void;
  showPrompt: boolean;
  target: ReactNode;
}

const BasePrompt = ({
  children,
  dismissible = false,
  dismissPrompt,
  showPrompt,
  target,
}: PromptProps) => {
  const contextValue = useMemo(
    () => ({ dismissible, dismissPrompt }),
    [dismissible, dismissPrompt]
  );

  return (
    <PromptContext.Provider value={contextValue}>
      <Box position="relative" width="fit-content">
        <div>{target}</div>

        {showPrompt && (
          <div className={styles['promptContainer']}>{children}</div>
        )}
      </Box>
    </PromptContext.Provider>
  );
};

export const Prompt = Object.assign(BasePrompt, {
  Content: PromptContent,
});
